import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Stays an async IIFE. S7785 asks for top-level await here and `tsc` accepts it - module target is
// ES2022 - but the bundler does not: esbuild fails the build with "Top-level await is not available
// in the configured target environment" for the browserslist targets this app ships to
// (chrome119/edge119/firefox119/ios17/safari17 + 6 overrides). A green typecheck is not a green
// build; this was tried, and `npm run build` is what caught it. Revisit if browserslist moves.
//
// File-scoped disable, not eslint-disable-next-line: the rule reports on the closing
// `})().catch(...)` line, not on the opening one, so a next-line directive above the IIFE is inert
// (ESLint reports it as an unused directive). This file contains nothing but that IIFE.
/* eslint-disable unicorn/prefer-top-level-await */
(async () => {
  try {
    if (!customElements.get('vsn-navigation')) {
      await import('@visma-swno/vsn-navigation');
    }

    await bootstrapApplication(AppComponent, appConfig);
  } catch (err) {
    console.error('Failed to initialize application.', err);
    throw err;
  }
})().catch(() => undefined); // NOSONAR S7785: top-level await breaks the bundle, see the comment above
